import { LimitOrderCreator } from "./limitOrderCreator";

export class FOKOrderCreator extends LimitOrderCreator {}
